import { Button, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import PageModal from "./PageModal";
import PageList from "./PageList";
import SyncEndPoints from "../end-points/SyncEndPoints";
import EndPointsModal from "../sync-end-points/EndPointsModal";
import { useTranslation } from "react-i18next";
import RoleModal from "./RoleModal";

interface ActionItem {
  [key: string]: any;
}

const AccessRightList: React.FC = () => {
  const { t } = useTranslation();

  const [modalOpen, setOpenModal] = useState<boolean>(false);
  const [openRoleModal, setOpenRoleModal] = useState<boolean>(false);
  const [linkModalOpen, setLinkOpenModal] = useState<boolean>(false);

  const [getId, setFiledId] = useState<string>("");
  const [actionType, setActionType] = useState<string | null>(null);
  const [linkType, setLinkType] = useState<string | null>(null);

  const [actionItem, setActionItem] = useState<ActionItem>({});
  const [expandedRowKey, setExpandedRowKey] = useState<string | null>(null);
  const [searchTerm, setSearchTerm] = useState<string>("");

  const handleAdd = () => {
    setOpenModal(true);
    setActionType("add_page");
    setActionItem({});
  };

  const handleAddRole = () => {
    setOpenRoleModal(true);
    setActionType("add_role");
    setActionItem({});
  };

  const handleClose = () => {
    setOpenModal(false);
    setActionType("");
    setOpenRoleModal(false);
  };

  const handleLinkClose = () => {
    setLinkOpenModal(false);
    setActionType("");
  };

  const handleSubmit = (_e: React.FormEvent) => {
    // submit handler placeholder; modals own their own submit flow
  };

  return (
    <div className="access-rights-wrapper">
      <div className="access-rights-toolbar">
        <div className="access-rights-title">
          <span className="access-rights-title-dot" />
          {t("access_rights") || "Access Rights"}
        </div>

        <Input
          className="access-rights-search"
          allowClear
          placeholder={t("search_pages") || "Search pages..."}
          prefix={<SearchOutlined style={{ color: "#b09bbf" }} />}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        <div className="access-rights-actions">
          <Button onClick={handleAddRole} className="btn-role" type="primary">
            {t("role") || "Role"}
          </Button>
          <Button onClick={handleAdd} className="btn-page" type="primary">
            {t("add_page") || "Page"}
          </Button>
          <SyncEndPoints />
        </div>
      </div>

      <PageModal
        modalOpen={modalOpen}
        handleClose={handleClose}
        actionType={actionType || ""}
        id={getId}
        actionItem={actionItem}
        linkType={linkType || ""}
        setExpandedRowKey={setExpandedRowKey}
      />
      <RoleModal
        modalOpen={openRoleModal}
        handleClose={handleClose}
        handleSubmit={handleSubmit}
        actionType={actionType || ""}
        id={getId}
        actionItem={actionItem}
        linkType={linkType || ""}
        setExpandedRowKey={setExpandedRowKey}
      />
      <EndPointsModal
        actionType={actionType || ""}
        linkType={linkType || ""}
        linkModalOpen={linkModalOpen}
        handleLinkClose={handleLinkClose}
        id={getId || ""}
        handleSubmit={handleSubmit}
        actionItem={actionItem}
      />

      <div className="access-rights-card">
        <PageList
          setOpenModal={setOpenModal}
          setActionType={setActionType}
          setFiledId={setFiledId}
          setActionItem={setActionItem}
          setLinkOpenModal={setLinkOpenModal}
          getId={getId}
          setExpandedRowKey={setExpandedRowKey}
          expandedRowKey={expandedRowKey}
          setLinkType={setLinkType}
          setOpenRoleModal={setOpenRoleModal}
          searchTerm={searchTerm}
        />
      </div>
    </div>
  );
};

export default AccessRightList;
